<template>
  <v-dialog persistent v-model="showModalDel" max-width="550" dark>
    <div id="modal-del-proj">
    <div v-if="loader" class="loader">
      <v-icon>mdi-loading mdi-spin</v-icon>
    </div>

    <!-- Modal Card -->
    <v-card>
      <v-card-title class="headline">
        <v-icon color="warning">warning</v-icon>
        <p> {{$tc('titles.youWillDelete', plurial ? 5 : 1)}} : </p>
      </v-card-title>
      <v-card-text>
        <ul>
          <div v-for="(project, index) in projects" :key="index">
            <li class="mb-2">
              <strong>{{project.name}}</strong> <br> 
              <span v-html="$t('texts.delProjects', {nbr :project.medias && project.medias.length || 0})"></span>
            </li>
          </div>
        </ul>
      </v-card-text>
      <v-card-actions class="center">
        <v-btn color="primary" flat @click="hide">{{$t('buttons.cancel')}}</v-btn>
        <v-btn color="primary" flat @click="confirmDelete">{{$t('buttons.deleteAll')}}</v-btn>
      </v-card-actions>
    </v-card>
    </div>
  </v-dialog>
</template>
<script>
export default {
  props: {
    showModalDel: Boolean,
    projects: Array
  },
  data() {
    return {
      loader: false,
    };
  },
  computed: {
    plurial() {
      return this.projects.length > 1;
    }
  },
  watch: {
    projects: {
      async handler(){
        if (this.projects[0].medias !== undefined) return;
        let images = this.$store.getters['image/getImages'];
        if ((images) === null)
          images = await this.$store.dispatch("image/getImages");
        this.projects.forEach(proj => {
          let medias = this.$store.getters["image/getImgProject"](proj.uuid);
          this.$set(proj, 'medias', medias);
        });
      },
      deep: true
    }
  },  
  methods: {
    hide() {
      this.$emit('close');
    },
    async confirmDelete() {
      this.loader = true;
      this.projects.map(proj => {
        proj.medias.forEach(img => this.$store.dispatch('image/deleteMedia', img.uuid));
        return this.$store.dispatch('project/delProject', proj.uuid)
      });
      await this.projects[0];
      setTimeout(() => {
        this.loader = false;
      }, 300);
      this.hide();
    },
  }
};
</script>
<style lang="sass">
#modal-del-proj 
  position: relative
  li 
    word-break: break-word
  .v-btn:focus 
    outline: none

  .headline 
    display: flex !important
    i
      flex: 1
    p
      flex: 5
      margin: 0

  .loader 
    position: absolute
    width: 100%
    height: 100%
    z-index: 1000
    background-color: rgba(0, 0, 0, .5)

  .loader i 
    position: absolute
    z-index: 1050
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    font-size: 3rem

</style>